import { TIdentificationStore } from '~/store/identification-form/types.ts';
import { PayloadAction } from '@reduxjs/toolkit';
import { EMPTY_ERROR } from '~/constants/errorCodes.ts';
import { TManagersAndRepresentatives } from '~/modules/identification/forms/ManagersAndRepresentatives/types';

export const setManagementStructureSyncAssetManagers = (
  state: TIdentificationStore,
  action: PayloadAction<TManagersAndRepresentatives>
) => {
  state.loading = false;
  state.error = EMPTY_ERROR;
  const assetManagers = action.payload?.assetManagers?.sort(
    (a, b) => (b.isHead ? 1 : 0) - (a.isHead ? 1 : 0)
  );
  const newState = { ...action.payload, assetManagers: assetManagers };
  state.formData.managersAndRepresentatives = newState;
};
